'use client'

import { type ReactNode } from 'react'

interface LogosCarouselProps {
  children: ReactNode[]
}

export const LogosCarousel = ({ children }: LogosCarouselProps) => {
  // Duplicate items for seamless infinite scroll
  const items = [...children, ...children]

  return (
    <div className="overflow-hidden">
      <div
        className="flex animate-[scroll-logos_60s_linear_infinite] items-center gap-[40px] md:gap-[120px]"
        style={{ width: 'max-content' }}
      >
        {items.map((child, i) => (
          <div key={i} className="h-[60px] w-full max-w-[120px] shrink-0 px-3 md:px-0">
            {child}
          </div>
        ))}
      </div>
    </div>
  )
}
